import React, {useEffect, useState} from 'react'
import DHDialog from "../../general/DHDialog";
import DHButtonSave from "../../general/DHButtonSave";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHTextField from "../../general/DHTextField";
import DHSwitch from "../../general/DHSwitch";
import DHButtonNew from "../../general/DHButtonNew";
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";

export default function LigaVereinVerwaltenDialog({eventOperatorId, selectedVerein, onRefresh, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [working, setWorking] = useState(false);

    const [id, setId] = useState(undefined);
    const [bezeichnung, setBezeichnung] = useState("");
    const [aktiv, setAktiv] = useState(true);

    useEffect(() => {
        if( selectedVerein ) {
            setId(selectedVerein.id);
            setBezeichnung(selectedVerein.bezeichnung);
            setAktiv(selectedVerein.aktiv);
        }
    }, [selectedVerein]);

    const save = () => {
        setWorking(true);
        let data = {id: id, bezeichnung: bezeichnung, aktiv: aktiv}
        let url = ConfigUtil.getConfig().resourceUrls.league + "/verein/save/" + eventOperatorId;
        FetchUtil.fetchPost(url,
            data,
            json => {
                setId(json.id);
                setInfoMessage("Speichern erfolgreich...");
                onRefresh();
                setWorking(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setWorking(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setWorking(false);
            });
    }


    const initDialog = () => {
        setId(undefined);
        setBezeichnung("");
        setAktiv(true);
    }

    const isDisabled = () => {
        return bezeichnung === "";
    }

    const getDataArea = () => {
        return <div style={{padding: 20}}>
            <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                onClearErrorMessage={() => setErrorMessage(undefined)}/>
            <DHTextField id="id-name" label="Name" width={500} required={true} value={bezeichnung} onChange={(text) => setBezeichnung(text)}/>
            <div style={{marginTop: 10}}>
                <DHSwitch id="id-aktiv" label="Aktiv" value={aktiv} onChange={(value) => setAktiv(value)} required={false}/>
            </div>
        </div>
    }

    const getButtons = () => {
        return [<DHButtonSave onClick={() => save()} working={working} disabled={isDisabled()}/>,
            <DHButtonNew onClick={() => initDialog()}/>];
    }


    return <DHDialog onClose={() => onClose()} title="Verein verwalten" show={true} showCloseButton={true}
                     buttons={getButtons()} comp={getDataArea()}/>
}
